import { Select, Button1, Button2, TagInput } from "../index";
import logo from "../../assets/icons/Ellipse 81.png";
import downIcon from "../../assets/icons/chevron-down.png";
import warningIcon from "../../assets/icons/warning-icon.png";
import plusIcon from "../../assets/icons/plus-circle-white.png";
import { Input, Modal, message } from "antd";
import { useEffect, useState } from "react";
import { accountsApi, fundingBankAccountsApi } from "../../api/endpoints";
import { useFundingBankAccounts } from "../../data/live";

const CATEGORIES = ["Top-up", "Salary", "Refund", "Other"];

const DirectDebit = ({
  accounts = [],
  targetAccountId,
  setTargetAccountId,
  targetAccount,
  onSuccess,
}) => {
  const {
    fundingBankAccounts,
    loading: bankAccountsLoading,
    refresh: refreshFundingBankAccounts,
  } = useFundingBankAccounts();
  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [selectedBankAccountId, setSelectedBankAccountId] = useState("");
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [savingBankAccount, setSavingBankAccount] = useState(false);
  const [bankForm, setBankForm] = useState({
    bankName: "",
    accountName: "",
    bsb: "",
    accountNumber: "",
  });

  // Only AUD accounts are accepted for Add Funds at this time
  const audAccounts = accounts.filter((a) => a.currency === "AUD");
  const accountOptions = audAccounts.map((a) => ({
    name: `${a.currency} ****${(a.iban || a.accountNumber || "0000").slice(
      -4
    )}${a.isDefault ? " (Default)" : ""}`,
    value: a.id,
  }));

  useEffect(() => {
    if (!fundingBankAccounts.length) {
      setSelectedBankAccountId("");
      return;
    }
    if (
      !selectedBankAccountId ||
      !fundingBankAccounts.some((item) => item.id === selectedBankAccountId)
    ) {
      const def =
        fundingBankAccounts.find((item) => item.isDefault) ||
        fundingBankAccounts[0];
      setSelectedBankAccountId(def.id);
    }
  }, [fundingBankAccounts, selectedBankAccountId]);

  const bankAccountOptions = fundingBankAccounts.map((account) => ({
    name: `${account.bankName} • ${account.accountNumberMasked}${
      account.isDefault ? " (Default)" : ""
    }`,
    value: account.id,
  }));

  const selectedBankAccount = fundingBankAccounts.find(
    (account) => account.id === selectedBankAccountId
  );

  const updateBankForm = (field, value) => {
    setBankForm((current) => ({ ...current, [field]: value }));
  };

  const handleSaveBankAccount = async () => {
    setError(null);
    setSavingBankAccount(true);
    try {
      const created = await fundingBankAccountsApi.create({
        bankName: bankForm.bankName,
        accountName: bankForm.accountName || null,
        bsb: bankForm.bsb,
        accountNumber: bankForm.accountNumber,
      });
      await refreshFundingBankAccounts();
      setSelectedBankAccountId(created.id);
      setBankForm({
        bankName: "",
        accountName: "",
        bsb: "",
        accountNumber: "",
      });
      setBankModalOpen(false);
      message.success("Bank account added");
    } catch (e) {
      setError(
        e.response?.data?.message ||
          e.response?.data?.error ||
          e.message ||
          "Unable to add bank account"
      );
    } finally {
      setSavingBankAccount(false);
    }
  };

  const handleSubmit = async () => {
    setError(null);
    if (!targetAccountId) {
      setError("Please select a target account");
      return;
    }
    if (!amount || Number(amount) <= 0) {
      setError("Enter a valid amount");
      return;
    }
    if (!selectedBankAccountId) {
      setError("Add and select a linked bank account");
      return;
    }
    setSubmitting(true);
    try {
      const res = await accountsApi.topup(targetAccountId, {
        amount: Number(amount),
        fundingBankAccountId: selectedBankAccountId,
        note: category || undefined,
      });
      message.success(
        res?.message ||
          `Direct debit pending, Ref: ${res?.reference}. ${amount} ${
            targetAccount?.currency || "AUD"
          } credits in ~1 hour.`
      );
      setAmount("");
      onSuccess?.();
    } catch (e) {
      setError(e.response?.data?.error || e.message || "Direct debit failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-5 mb-5  p-3">
        <span className="fs-5 fw-bold">Add Funds Via Direct Debit</span>
        <div className="d-flex flex-column mt-4 gap-2">
          <span className="fs14px">Top up to account</span>
          <Select
            value={targetAccountId}
            options={accountOptions}
            defaultValue="Select your account"
            className="rounded-2 p-3"
            onChange={(e) => setTargetAccountId(e.target.value)}
          />
        </div>

        <div className="d-flex flex-column mt-2">
          <div className="d-flex justify-content-between align-items-center">
            <span className="fs14px">From</span>
            <Button2
              icon={<img src={plusIcon} alt="add" />}
              buttonName={"Bank Account"}
              className={"btn-dark p-1 px-3"}
              divClassName={"gap-2 "}
              onClick={() => setBankModalOpen(true)}
            />
          </div>

          {fundingBankAccounts.length > 0 ? (
            <div className="d-flex flex-column gap-2 mt-2">
              <Select
                value={selectedBankAccountId}
                options={bankAccountOptions}
                defaultValue={
                  bankAccountsLoading
                    ? "Loading bank accounts"
                    : "Select bank account"
                }
                className="rounded-2 p-3"
                onChange={(e) => setSelectedBankAccountId(e.target.value)}
              />
              {selectedBankAccount && (
                <div className="d-flex justify-content-between align-items-center border p-3 rounded-2">
                  <div className="d-flex gap-2 align-items-center">
                    <img src={logo} alt="bank" />
                    <div className="d-flex flex-column ">
                      <span className="fw-medium">
                        {selectedBankAccount.bankName}
                      </span>
                      <span
                        className="fs14px fw-medium"
                        style={{ color: "#636363" }}
                      >
                        {selectedBankAccount.bsb} • Account{" "}
                        {selectedBankAccount.accountNumberMasked}
                      </span>
                    </div>
                  </div>

                  <img src={downIcon} alt="down-icon" width={20} height={20} />
                </div>
              )}
            </div>
          ) : (
            <div className="mt-2 border p-3 rounded-2">
              <span className="fw-medium">No linked bank account</span>
              <p className="fs12px m-0 mt-1" style={{ color: "#636363" }}>
                Add your own bank account before using direct debit.
              </p>
            </div>
          )}

          <div className="d-flex gap-3 mt-3">
            <div className="w-75">
              <label className="fs12px">Amount</label>
              <Input
                className="p-3 w-100"
                placeholder="0.00"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div>
              <label className="fs12px">Currency</label>
              <Select
                value={targetAccount?.currency || "AUD"}
                options={[
                  {
                    name: targetAccount?.currency || "AUD",
                    value: targetAccount?.currency || "AUD",
                  },
                ]}
                className="p-3 "
                selectStyle={{ width: "100%" }}
                disabled
              />
            </div>
          </div>

          <div
            className="d-flex rounded-4 p-3 gap-2 mt-2 align-items-center"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <img
              src={warningIcon}
              alt="warn"
              width={44}
              className="align-self-start"
            />

            <div className="d-flex flex-column gap-1">
              <span className="fw-medium">Confirm to top up</span>
              <span
                className="fs12px fw-medium pe-3"
                style={{ color: "#4A4A4A" }}
              >
                You are sending {amount || "0.00"}{" "}
                {targetAccount?.currency || "AUD"} from your linked bank account
                to your wallet.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6 mb-5  p-3">
        <div className="d-flex flex-column mt-4">
          <span className="fs-5 fw-bold">Additional Details</span>
          <div className="d-flex flex-column gap-2 mt-4">
            <label className="fs12px ">Category</label>
            <Select
              value={category}
              options={CATEGORIES.map((c) => ({ name: c, value: c }))}
              defaultValue="Choose Category"
              className="rounded-2 p-3"
              onChange={(e) => setCategory(e.target.value)}
            />
          </div>
          <div className="d-flex flex-column gap-2 mt-4">
            <label className="fs12px ">Tags</label>
            <TagInput
              className="border py-3"
              inputBgColor="transparent"
              tagColor="#1bbb6b"
              tagTextColor="#000"
              limit={10}
              placeholder="Add up to 10 Tags"
            />
          </div>
        </div>
      </div>

      {error && (
        <div className="col-12 p-2">
          <span className="fs12px" style={{ color: "#FC555B" }}>
            {error}
          </span>
        </div>
      )}

      <div className="d-flex justify-content-md-end justify-content-between p-2 gap-3">
        <Button1
          buttonName={"Save as Draft"}
          className={"btn-outline-success"}
        />
        <Button1
          buttonName={submitting ? "Processing..." : "Submit"}
          className="btn-dark "
          onClick={handleSubmit}
          disabled={submitting || !selectedBankAccountId}
        />
      </div>

      <Modal
        title="Add bank account"
        open={bankModalOpen}
        onCancel={() => setBankModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <div className="d-flex flex-column gap-3 pt-2">
          <div className="d-flex flex-column gap-2">
            <label className="fs12px">Bank name</label>
            <Input
              className="p-3"
              placeholder="Bank name"
              value={bankForm.bankName}
              onChange={(e) => updateBankForm("bankName", e.target.value)}
            />
          </div>
          <div className="d-flex flex-column gap-2">
            <label className="fs12px">Account name</label>
            <Input
              className="p-3"
              placeholder="Account holder name"
              value={bankForm.accountName}
              onChange={(e) => updateBankForm("accountName", e.target.value)}
            />
          </div>
          <div className="d-flex gap-3">
            <div className="w-50 d-flex flex-column gap-2">
              <label className="fs12px">BSB</label>
              <Input
                className="p-3"
                placeholder="123-456"
                value={bankForm.bsb}
                onChange={(e) => updateBankForm("bsb", e.target.value)}
              />
            </div>
            <div className="w-50 d-flex flex-column gap-2">
              <label className="fs12px">Account number</label>
              <Input
                className="p-3"
                placeholder="Account number"
                value={bankForm.accountNumber}
                onChange={(e) =>
                  updateBankForm("accountNumber", e.target.value)
                }
              />
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 pt-2">
            <Button1
              buttonName="Cancel"
              className="btn-outline-success"
              onClick={() => setBankModalOpen(false)}
            />
            <Button1
              buttonName={savingBankAccount ? "Saving..." : "Add account"}
              className="btn-dark"
              onClick={handleSaveBankAccount}
              disabled={savingBankAccount}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DirectDebit;
